const squareBg:any = [ '', '/images/Recognizbadge/recognitionBg1.svg', '/images/Recognizbadge/recognitionBg2.svg', '/images/Recognizbadge/recognitionBg3.svg' ];
const badges:any = [ '', '/images/Recognizbadge/badge1.svg', '/images/Recognizbadge/badge2.svg', '/images/Recognizbadge/badge3.svg' ];
const rectangleBg:any = [ '', '/images/banner/recognizationBanner.svg', '/images/banner/recognizationBanner1.svg', '/images/banner/recognizationBanner2.svg' ];

export const RecognisedBackGround = (type:string, temp:string, badge:string) =>
{
	const tempIndex:any = parseInt(temp?.split('')[1]);
	const bagdeIndex:any = parseInt(badge?.split('')[1]);

	if (type === 'square')
	{
		return { background: squareBg[tempIndex], badge: badges[bagdeIndex] };
	}
	else
	{
		return { background: rectangleBg[tempIndex], badge: badges[bagdeIndex] };
	}
};